import { AppInformation } from "./AppInformation";

const NoAppointmentFound = () => {
    return (
        <div className="no-appointment-found">
        <h2>No Appointment Found</h2>
        <p>There are no appointments available for you at the moment.</p>
        <AppInformation />
        </div>
    );
}

export default NoAppointmentFound;